import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource-variable/manrope';
import '../styles.css';
import App from './App';
import Home from './Home';
import { browserParentEnv, createParentChannel } from './parent';

const LINK_PATH_RE = /^\/l\/([A-Za-z0-9_-]{3,100})$/;

// Read (and strip) the fragment before anything renders.
const channel = createParentChannel(browserParentEnv());
const match = LINK_PATH_RE.exec(window.location.pathname);

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(match ? <App slug={match[1]} channel={channel} /> : <Home />);
}
